import React, { useState } from "react";
import { BannerObjData } from "./Promotions";
import CustomButton from "./CustomButton";
import { useAppSelector } from "@hypexone/uicore";

interface PromotionCardProps {
  bannerData: BannerObjData;
  onKnowMorePress: (banner: BannerObjData) => void;
}

const PromotionCard: React.FC<PromotionCardProps> = ({
  bannerData,
  onKnowMorePress,
}) => {
  const { publicUrl: bannerUrl, imageContent: contentHtmlString } = bannerData;

  const onKnowMoreClick = () => onKnowMorePress(bannerData);
  const {langData} = useAppSelector((state) => state.cms);

  return (
    <div className="border ">
      <img src={bannerUrl} alt={"DepositBanner"} />
      <div className="banner-display-content">
        {/* <RenderHtml htmlString={contentHtmlString} /> */}
      </div>
      <div className="flex justify-end p-1.5 text-white bg-black1"> 
        <CustomButton text={langData?.['know_more']} onClick={onKnowMoreClick} />
      </div>
    </div>
  );
};

export default PromotionCard;
